import React, { useEffect } from 'react'
import io from 'socket.io-client'

import { useDispatch, useSelector } from 'react-redux'
import Table from '../../components/page-components/apps/deferred-revenue-actions/table'
import Loading from '../../components/page-components/apps/deferred-revenue-actions/loading'
import Error from '../../components/page-components/apps/deferred-revenue-actions/error'
import { getDeferredRevenueActions } from '../../redux/actions/appActions'
import PageWrapper from '../../components/layout/sage-page-wrapper'
import { CONST_IO } from '../../constants/general'
import { REDUX_CONST } from '../../redux/constants'

const DeferredRevenueActions = () => {
	const dispatch = useDispatch()
	const deferredRevenueActionsRdx = useSelector(
		(state) => state.getDeferredRevenueActions,
	)
	const { data, loading, error } = deferredRevenueActionsRdx

	// useEffect(() => {
	// 	return () => {}
	// }, [error, data, loading])

	useEffect(() => {
		dispatch(getDeferredRevenueActions())

		return () => {}
	}, [])

	useEffect(() => {
		// io('http://localhost:5000')
		// Connect to the Socket.IO server
		// Replace 'http://localhost:5000' with your server's URL
		//const socket = io('http://localhost:5000', { transports: ['websocket'] })
		const socket = io('https://www.nvoqe.com', { transports: ['websocket'] })
		// Setup event listeners

		socket.on(CONST_IO.events.WORKER_READY, (data) => {
			if (data.action === CONST_IO.actions.DEFERRED_REVENUE_ACTIONS) {
				const { message, data: newRows } = data.payload

				dispatch({
					type: REDUX_CONST.appConstants.getDeferredRevenueActions.success,
					payload: {
						message,
						data: newRows, // immediately populate your table
					},
				})
			}
		})

		// Clean up the effect
		return () => socket.disconnect()
	}, [])

	return (
		<PageWrapper showNavigation={false}>
			{loading && <Loading />}
			{data?.message && (
				<div className='flex flex-col justify-center items-center'>
					<div className='w-full text-center pb-4 font-bold'>
						{data.message}
					</div>
				</div>
			)}
			{data?.data?.length > 0 && <Table data={data} />}
			{data?.data?.length === 0 && (
				<div className='flex flex-col justify-center items-center'>
					<div className='w-full text-center pb-4 font-bold'>
						Congrats! Nothing to do here!
					</div>
					<img
						src='/images/sage/taskCompleted.png'
						alt=''
						className='block mx-auto md:mx-0 '
					/>
				</div>
			)}

			{error && <Error error={error} />}
		</PageWrapper>
	)
}

export default DeferredRevenueActions
